import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SyncBillomatInvoicesForStoreMutationVariables = Types.Exact<{
  store_id: Types.Scalars['ID'];
}>;


export type SyncBillomatInvoicesForStoreMutation = { __typename?: 'Mutation', syncBillomatInvoicesForStore?: { __typename?: 'SyncBillomatInvoicesResult', total: number, synced: number, errors: number, errorIds: Array<string> } | null };


export const SyncBillomatInvoicesForStoreDocument = gql`
    mutation syncBillomatInvoicesForStore($store_id: ID!) {
  syncBillomatInvoicesForStore(store_id: $store_id) {
    total
    synced
    errors
    errorIds
  }
}
    `;
export type SyncBillomatInvoicesForStoreMutationFn = Apollo.MutationFunction<SyncBillomatInvoicesForStoreMutation, SyncBillomatInvoicesForStoreMutationVariables>;

/**
 * __useSyncBillomatInvoicesForStoreMutation__
 *
 * To run a mutation, you first call `useSyncBillomatInvoicesForStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncBillomatInvoicesForStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncBillomatInvoicesForStoreMutation, { data, loading, error }] = useSyncBillomatInvoicesForStoreMutation({
 *   variables: {
 *      store_id: // value for 'store_id'
 *   },
 * });
 */
export function useSyncBillomatInvoicesForStoreMutation(baseOptions?: Apollo.MutationHookOptions<SyncBillomatInvoicesForStoreMutation, SyncBillomatInvoicesForStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncBillomatInvoicesForStoreMutation, SyncBillomatInvoicesForStoreMutationVariables>(SyncBillomatInvoicesForStoreDocument, options);
      }
export type SyncBillomatInvoicesForStoreMutationHookResult = ReturnType<typeof useSyncBillomatInvoicesForStoreMutation>;
export type SyncBillomatInvoicesForStoreMutationResult = Apollo.MutationResult<SyncBillomatInvoicesForStoreMutation>;
export type SyncBillomatInvoicesForStoreMutationOptions = Apollo.BaseMutationOptions<SyncBillomatInvoicesForStoreMutation, SyncBillomatInvoicesForStoreMutationVariables>;